import React, { useCallback, useEffect, useState } from 'react';
import { message } from 'antd';

import { usePagination } from 'hooks/usePagination';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { ServicesService } from 'services/ServicesService';
import { PromocodesTable } from './PromocodesTable';

function Promocodes() {
  useDocumentTitle('Промокоды');
  const { setCount } = useHeaderChanger('Промокоды');
  const [promocodes, setPromocodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { page, totalRows, perPage, setTotalRows, setPagination } =
    usePagination();

  useEffect(() => {
    fetchPromocodes();
  }, [page, perPage, searchQuery]);

  const fetchPromocodes = async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await ServicesService.getPromocodes(
        page,
        perPage,
        searchQuery
      );

      setPromocodes(items);
      setCount(total);
      setTotalRows(total);
    } catch (err) {
      message.error('Не удалось загрузить промокоды');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = useCallback((e) => {
    setSearchQuery(e.target.value);
  }, []);

  return (
    <PromocodesTable
      items={promocodes}
      loading={loading}
      current={page}
      pageSize={perPage}
      totalRows={totalRows}
      onChange={setPagination}
      onSearch={handleSearch}
    />
  );
}

export { Promocodes };
